module.exports = __webpack_public_path__ + "img/invitation_iamge_more@2x.e49ecbef.png";